import { Badge, BadgeColors, DoneIcon } from "@dotnet/telematics-design-system";

const PermissionMatrix = () => {
    return (
        <Badge
            color={BadgeColors.success}
            sx={{
                padding: "1px 7px"
            }}
        >
            <DoneIcon />
        </Badge>
    );
};

export default PermissionMatrix;
